import * as React from 'react';
import {
  Button,
  DatePicker,
  Form,
  Icon,
  Input,
  Row,
  Upload,
  message,
} from 'antd';
import * as moment from 'moment';
import * as NProgress from 'nprogress';

import SessionStore from '../stores/SessionStore';

import { distributeAssignments } from '../PoolAPI';

interface DistributeAssignmentsState {
  assignmentDay: moment.Moment;
  notificationEmail: string;
  fileToUpload?: File;
}

export class DistributeAssignmentsView extends React.Component<
  {},
  DistributeAssignmentsState
> {
  constructor(props: {}) {
    super(props);

    this.state = {
      assignmentDay: moment().add(1, 'd'),
      notificationEmail: SessionStore.getEmail(),
    };
    NProgress.configure({
      showSpinner: false,
    });
  }

  render() {
    const changeDay = (d: moment.Moment) => {
      this.setState({
        assignmentDay: d,
      });
    };

    const beforeUpload = (file: File) => {
      this.setState({
        fileToUpload: file,
      });
      return false;
    };
    const upload = async () => {
      if (this.state.fileToUpload === undefined) {
        return;
      }
      NProgress.start();
      message.warning('Processing file...');
      const r = await distributeAssignments(
        this.state.fileToUpload,
        this.state.assignmentDay,
        this.state.notificationEmail
      );
      if (r.status === 200) {
        message.info(
          'You will receive an email when all of the assignments have finished uploading.'
        );
      } else if (r.status >= 400) {
        const text = await r.text();
        message.error('Internal error: ' + text);
      }
      NProgress.done();
    };

    return (
      <div style={{ flexDirection: 'column' }}>
        <Row className="buffer">
          <h2>New Assignments Date:</h2>
          <DatePicker
            allowClear={false}
            value={this.state.assignmentDay}
            onChange={changeDay}
          />
        </Row>
        <Row className="buffer">
          <h2>Excel pool file:</h2>
          <Upload
            accept=".xls"
            action="/api/distribute_assignments"
            beforeUpload={beforeUpload}
            multiple={false}
            showUploadList={false}
          >
            <Button>
              <Icon type="upload" /> Select Excel Pool File
            </Button>
            {this.state.fileToUpload === undefined ? null : (
              <div className="small-buffer">
                (<strong>{this.state.fileToUpload.name}</strong> selected)
              </div>
            )}
          </Upload>
        </Row>
        {this.state.fileToUpload === undefined ? null : (
          <span className="buffer">
            <Form>
              <h2>Email to notify once upload finishes:</h2>
              <Form.Item style={{ width: '300px' }}>
                <Input
                  value={this.state.notificationEmail}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    this.setState({
                      notificationEmail: e.target.value,
                    });
                  }}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={upload}>
                  Upload Assignment to Website
                </Button>
              </Form.Item>
            </Form>
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DistributeAssignmentsView.tsx